import { useReportsDashboardDerived } from './useReportsDashboardDerived';
import {
  useReportsDashboardFetch,
  type ReportsDashboardFetchParams,
} from './useReportsDashboardFetch';

export type ReportsDashboardLoadParams = ReportsDashboardFetchParams;

export function useReportsDashboardLoad(params: ReportsDashboardLoadParams) {
  const fetch = useReportsDashboardFetch(params);
  const derived = useReportsDashboardDerived({
    fetch,
    customerModuleEnabled: params.customerModuleEnabled,
    mercadopagoQrMethodAllowed: params.mercadopagoQrMethodAllowed,
  });

  const { paymentMethods: _paymentMethods, ...fetchPublic } = fetch;

  return {
    ...fetchPublic,
    ...derived,
  };
}
